/**
 * Collection Stock Flags
 * Displays a stock availability flag on product cards when items are available at the selected store
 */

(function() {
  'use strict';

  // Use global cookie utilities
  const getCookie = window.CookieUtils ? window.CookieUtils.getCookie : function(name) {
    // Fallback if cookie-utils.js hasn't loaded yet
    const nameKey = name + '=';
    const cookieParts = document.cookie.split(';');
    for (let i = 0; i < cookieParts.length; i++) {
      let cookie = cookieParts[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameKey) === 0) {
        return cookie.substring(nameKey.length, cookie.length);
      }
    }
    return '';
  };

  /**
   * Get the collect location ID from cookie
   * @returns {string|null} Store ID or null if not found
   */
  function getCollectLocationId() {
    const locationId = getCookie('ww_collectLocationId');
    return locationId || null;
  }

  /**
   * Get the wellness now location ID from cookie
   * @returns {string|null} Store ID or null if not found
   */
  function getWellnessNowLocationId() {
    const locationId = getCookie('ww_wellnessNowLocationId');
    return locationId || null;
  }

  /**
   * Check if a product is in stock at the selected store
   * @param {string} locationIds - Comma-separated list of location IDs
   * @param {number} selectedStoreId - The selected store ID
   * @returns {boolean} True if product is in stock at selected store
   */
  function isInStockAtStore(locationIds, selectedStoreId) {
    if (!locationIds || !selectedStoreId) {
      return false;
    }

    const locationArray = locationIds.split(',').map(id => id.trim());
    return locationArray.includes(String(selectedStoreId));
  }

  /**
   * Create and return the collect stock flag badge with store icon and text
   * @returns {string} HTML markup for the collect badge
   */
  function createCollectBadgeIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 11 10" fill="none">
        <path d="M4.10156 9.34998V6.34998H6.60156V9.34998" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.35156 9.34996V4.82446" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.35156 9.34996V4.82446" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.3516 9.34998H0.351562" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.85156 3.59998C2.85156 4.29033 2.29192 4.84998 1.60156 4.84998C0.911207 4.84998 0.351562 4.29033 0.351562 3.59998V3.01543C0.351568 2.94271 0.367437 2.87086 0.398063 2.8049L1.26893 0.928901C1.43283 0.575847 1.7867 0.34998 2.17594 0.349976H8.52719C8.91644 0.349976 9.27032 0.575848 9.43422 0.928911L10.3051 2.80486C10.3357 2.87082 10.3516 2.94267 10.3516 3.01539V3.59998C10.3516 4.29033 9.79192 4.84998 9.10156 4.84998C8.41121 4.84998 7.85156 4.29033 7.85156 3.59998" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.85156 3.59998C7.85156 4.29033 7.29192 4.84998 6.60156 4.84998C5.91121 4.84998 5.35156 4.29033 5.35156 3.59998" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.35156 3.59998C5.35156 4.29033 4.79192 4.84998 4.10156 4.84998C3.41121 4.84998 2.85156 4.29033 2.85156 3.59998" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span style="color: white; font-size: 13px; font-weight: 400; line-height: 1; white-space: nowrap;">Collect</span>
    `;
  }

  /**
   * Create and return the wellness now badge with delivery truck icon and text
   * @returns {string} HTML markup for the wellness now badge
   */
  function createWellnessNowBadgeIcon() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
        <path d="M5.2198 0.42016H7.61975C7.95094 0.42016 8.21973 0.688953 8.21973 1.02015V7.02H0.419922M2.21988 9.66953H1.01991C0.688715 9.66953 0.419922 9.40074 0.419922 9.06955V5.82003M8.22002 2.22012H10.8138C11.0592 2.22012 11.2799 2.36951 11.3705 2.59751L12.3341 5.00585C12.3905 5.14744 12.4199 5.29864 12.4199 5.45104V9.01975C12.4199 9.35094 12.1511 9.61973 11.8199 9.61973H10.7214M8.82011 9.67181H4.12222M12.4199 6.42001H10.02V4.02007H11.9399M0.419922 0.420013H3.41985M0.419922 2.21997H2.21988M1.01991 4.01993H0.419922M10.4428 8.99713C10.8142 9.36852 10.8142 9.97031 10.4428 10.3411C10.0714 10.7125 9.46964 10.7125 9.09885 10.3411C8.72745 9.96971 8.72745 9.36792 9.09885 8.99713C9.47024 8.62574 10.072 8.62574 10.4428 8.99713ZM3.84216 8.99735C4.21355 9.36874 4.21355 9.97052 3.84216 10.3413C3.47077 10.7127 2.86899 10.7127 2.4982 10.3413C2.12741 9.96992 2.12681 9.36814 2.4982 8.99735C2.86959 8.62656 3.47077 8.62596 3.84216 8.99735Z" stroke="white" stroke-width="0.84" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span style="color: white; font-size: 13px; font-weight: 400; line-height: 1; white-space: nowrap;">NOW</span>
    `;
  }

  /**
   * Initialize stock flags on all product cards
   */
  function initStockFlags() {
    const collectLocationId = getCollectLocationId();
    const wellnessNowLocationId = getWellnessNowLocationId();

    console.log('[Stock Flags] Initializing with cookies:', {
      collectLocationId,
      wellnessNowLocationId,
      allCookies: document.cookie
    });

    // Find all product cards with stock location data
    const productCards = document.querySelectorAll('.product-card[data-stock-locations]');

    console.log('[Stock Flags] Found', productCards.length, 'product cards');

    productCards.forEach((card, index) => {
      const locationIds = card.getAttribute('data-stock-locations');
      const expressBadge = card.querySelector('.stock-flag--express');
      const collectBadge = card.querySelector('.stock-flag--collect');

      if (index === 0) {
        console.log('[Stock Flags] First product card data:', {
          locationIds,
          hasExpressBadge: !!expressBadge,
          hasCollectBadge: !!collectBadge
        });
      }

      // Track badge visibility states
      let isCollectVisible = false;
      let isExpressVisible = false;

      // Handle Collect badge first
      if (collectBadge) {
        collectBadge.classList.remove('stock-flag--visible');
        collectBadge.innerHTML = '';

        if (collectLocationId && isInStockAtStore(locationIds, collectLocationId)) {
          console.log('[Stock Flags] Product', index, 'available for Collect');
          collectBadge.innerHTML = createCollectBadgeIcon();
          collectBadge.classList.add('stock-flag--visible');
          isCollectVisible = true;
        } else if (collectLocationId) {
          console.log('[Stock Flags] Product', index, 'NOT available at collect location', collectLocationId, 'Product locations:', locationIds);
        }
      }

      // Handle Express badge
      if (expressBadge) {
        expressBadge.classList.remove('stock-flag--visible', 'stock-flag--wellness-now');
        expressBadge.innerHTML = '';

        if (wellnessNowLocationId && isInStockAtStore(locationIds, wellnessNowLocationId)) {
          expressBadge.innerHTML = createWellnessNowBadgeIcon();
          expressBadge.classList.add('stock-flag--visible', 'stock-flag--wellness-now');
          isExpressVisible = true;
        }

        // Reset any previously applied margin
        expressBadge.style.marginLeft = '0';
      }
    });
  }

  // Expose initStockFlags globally so it can be called when delivery method changes
  window.initStockFlags = initStockFlags;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockFlags);
  } else {
    initStockFlags();
  }

  // Re-initialize when products are dynamically loaded (e.g., filters, infinite scroll)
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain product cards
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList && node.classList.contains('product-card') || node.querySelector && node.querySelector('.product-card'))) {
              initStockFlags();
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
